import loadable from '@loadable/component';

export const ExperimentModal = loadable(
	() => import(/* webpackChunkName: "ExperimentModal" */ './ExperimentModal'),
);
